export const searchResultNoSuggestionProps = () => ({
  keyWord: {
    type: String,
    default: ""
  },
  categories: {
    type: Array,
    required: true
  }
})

export const useSearchResultNoSuggestion = (props) => {
  const withoutSelectionHeader = computed(() => {
    return props.categories.filter(
      (category) => !category.attributes.is_header_selections
    );
  });

  return {
    withoutSelectionHeader
  }
}